export const MODIFY_IMPORT_SHEETS_INFO = 'MODIFY_IMPORT_SHEETS_INFO';

export function modifyImportSheetsInfo(importSheetsInfo){
    return{
        type: MODIFY_IMPORT_SHEETS_INFO,
        mainState: {
            importSheetsInfo: importSheetsInfo
        }
    }
}